import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_TRACKER_DATA, GET_TRACKER_DATA_SUCCESS, GET_TRACKER_DATA_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getTrackerData({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/tracker-data`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_TRACKER_DATA_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_TRACKER_DATA_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_TRACKER_DATA_ERROR, payload: error });
  }
}

export function* watchGetTrackerData() {
  yield takeEvery(GET_TRACKER_DATA, getTrackerData);
}

function* getTrackerDataSaga() {
  yield all([fork(watchGetTrackerData)]);
}

export default getTrackerDataSaga;
